import useAppStore from "@/context/store";
import { getGdUserOrgs, switchOrg } from "@/services";
import { getOrgIdByUser } from "../gaoding";
import { createSingleFlight } from "../singleFlight";
import { GDErrCode } from "./customErrCode";
import { NormalizedError } from "./errorHandle";

/**
 * 遇到用户不在租户里的处理函数
 *
 * 处理逻辑：查询当前用户所有租户，然后自动切换到第一个租户
 *
 * 接口返回如下错误信息时， 做此处理：code: "10010412"  message: "用户不在租户里"
 *
 * createSingleFlight 保证多个接口触发时，只会执行一次
 */
const switchOrgFn = createSingleFlight(async function switchFn() {
  const orgs = await getGdUserOrgs();

  if (orgs.length > 0) {
    const user = useAppStore.getState().user;
    const orgId = getOrgIdByUser(user);

    // orgId在orgs中， 则自动切换到orgId
    if (orgId && orgs.find((org) => org.org_id === orgId)) {
      const res = await switchOrg(orgId);
      useAppStore.getState().refreshUser();
      return !res.err;
    }

    // 自动切换到第一个组织
    const res = await switchOrg(orgs[0].org_id);
    useAppStore.getState().refreshUser();

    return !res.err;
  } else {
    // 当前用户不存在租户
    return false;
  }
});

export async function handleUserNotInOrg(error: NormalizedError) {
  const { request } = error.config?.options || {};
  // 处理用户不在租户里的错误
  if (
    error?.code === GDErrCode.UserNotInOrg ||
    error?.code === GDErrCode.UnBindOrg
  ) {
    const handleResult = await switchOrgFn();
    if (handleResult) {
      error.config.retryTimes = (error.config.retryTimes || 0) + 1;
      // 处理成功后，重新发起请求
      const res = await request(error.config);
      return res;
    }
  }
}
